module.exports = __webpack_public_path__ + "static/media/Screenshot_4-thumb.89ed0802.png";